export default function DonationTypes(){
    const amiType = "Ami";
    const leauxalType = "Leauxcal";
    const rainAngelType = "Rain Angel";

    return {amiType, leauxalType, rainAngelType};
}